export default "__VITE_ASSET__JyoPuNwd__"